import Loader from "react-loader-spinner";
import React, { Fragment, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { CheckLg, X } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { changeCampaignCustomersStatus, getEventTypeList } from "../../store/api/CustomerApi";
const ModalChangeCustomerStatus = (props) => {
    const submitData = useRef({});
    const { show, setShow, customers, campaignID, onChangeStatus } = props;
    const dispatch = useDispatch();
    const { baseInfoes, preBaseInfoes, eventTypes } = useSelector(state => {
        return {
            baseInfoes: state.customerDataReducer.customerBaseInfoes,
            preBaseInfoes: state.customerDataReducer.preCustomerBaseInfoes,
            eventTypes: state.customerDataReducer.eventTypeList
        }
    });
    const campaignList = customers.find(c => c.CustOrPreCust === "مشتری")? baseInfoes.CampaignList: preBaseInfoes.CampaignList;
    const close = () => {
        setShow(false);
    }
    const submit = () => {
        if (customers.find(c => c.CustOrPreCust === "مشتری")) {
            submitData.current.Name = "customer";
        }
        else {
            submitData.current.Name = "precustomer";
        }
        submitData.current.IntValue = campaignID;
        submitData.current.ListValue = customers.map(c => c.ID);
        const onSuccess = (res) => {
            if (onChangeStatus) {
                onChangeStatus(res);
            }
            setShow(false);
        }
        dispatch(changeCampaignCustomersStatus(submitData.current, onSuccess));
    }
    useEffect(()=>{
        dispatch(getEventTypeList());
    },[])
    return (
        <Modal size="lg" show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>تغییر وضعیت مشتریان<span onClick={close} style={{ cursor: "pointer" }}>
                <X size={20} /></span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">

                {customers && customers.length > 0 &&
                    <Fragment>
                        <div className="row">
                            {customers.find(c => c.CustOrPreCust === "مشتری") &&
                                <div className="form-group col-md-3" >
                                    <label>وضعیت مشتریان</label>
                                    {baseInfoes === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    {baseInfoes?.StatusList && Array.isArray(baseInfoes.StatusList) &&
                                        <select className="form-control" onChange={e => submitData.current.ID = e.target.value}>
                                            <option value="">انتخاب کنید</option>
                                            {baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                        </select>
                                    }
                                </div>
                            }
                            {customers.find(c => c.CustOrPreCust === "مشتری بالقوه") &&
                                <div className='form-group col-md-3'>
                                    <label>وضعیت مشتریان بالقوه</label>
                                    {preBaseInfoes === "PENDING" &&
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                    }
                                    { preBaseInfoes?.StatusList && Array.isArray(preBaseInfoes.StatusList) &&
                                        <select className="form-control" onChange={e => submitData.current.ID = e.target.value}>
                                            <option value="">انتخاب کنید</option>
                                            {preBaseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                        </select>

                                    }
                                </div>

                            }
                            <div className="form-group col-md-3" >
                                <label>کمپین فروش</label>
                                {baseInfoes === "PENDING" || preBaseInfoes === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {campaignList && Array.isArray(campaignList) &&
                                    <select className="form-control" onChange={e => submitData.current.IntValue2 = e.target.value} defaultValue={campaignID??""}>
                                        <option value="">انتخاب کنید</option>
                                        <option value={-1} style={{ color: "red" }}>خروج از کمپین</option>
                                        {campaignList.map((item, i) => <option key={i} value={item.Item1}>{item.Item2}</option>)}
                                    </select>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 form-group">
                                <label>نوع رویداد</label>
                                <select className="form-control" onChange={e => submitData.current.Value = e.target.value}>
                                    <option value="">انتخاب کنید</option>
                                    {eventTypes && Array.isArray(eventTypes) &&
                                        eventTypes.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                </select>
                            </div>
                            <div className="col-md-3 form-group">
                                <label>تاریخ پیگیری</label>
                                <DatePicker name="AlarmDate" isGregorian={false} timePicker={false} className="form-control"
                                    onChange={value => { submitData.current.DateValue = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-6 form-group">
                                <label>شرح رویداد</label>
                                <input className="form-control" onChange={e => submitData.current.StringValue = e.target.value} />
                            </div>
                        </div>
                        <Button variant="success" className="group-Btn mt-2" onClick={submit}><CheckLg />&nbsp;ثبت اطلاعات</Button>
                    </Fragment>
                }

            </Modal.Body>
        </Modal>
    )
}
export default ModalChangeCustomerStatus;